export const SearchDropdownSkeleton = ({ rows = 3 }: { rows: number }) => {
  return (
    <div className="flex flex-col">
      {Array.from(Array(rows)).map((_, index) => (
        <div
          key={index}
          className="flex items-center animate-pulse gap-4 p-2"
        >
          <div className="flex flex-auto items-center gap-2">
            <div className="bg-ds-natural-150 rounded-sm w-4 h-4" />
            <div className="w-2/3 bg-ds-natural-150 rounded-sm h-3" />
          </div>
        </div>
      ))}
    </div>
  );
};
